document.addEventListener("DOMContentLoaded", () => {

/*
* Filter Blog
* */


if (document.querySelectorAll("#filterBlog").length > 0) {
let blogFilters = document.querySelectorAll('select.js-filter-blog');
let formFilterBlogs = document.querySelector('#filterBlog');
let resetBlog = document.querySelector('.js-reset-filter-blog');
if (resetBlog) {
    resetBlog.addEventListener('click', (e) => {
        for (const blogFilter of blogFilters) {
            blogFilter.value = "";
        }
        setTimeout(function () {
            sendFilterForm(formFilterBlogs, ".wrapper-blog");
        }, 250);
    });
}


for (const blogFilter of blogFilters) {
    blogFilter.addEventListener('change', (e) => {
        sendFilterForm(formFilterBlogs, ".wrapper-blog");
    });
}

formFilterBlogs.addEventListener("submit", function (e) {
    // e.preventDefault();
    sendFilterForm(formFilterBlogs, ".wrapper-blog");
});

}


function sendFilterForm(formFilterevent, wrapper) {
    let urlToSend = formFilterevent.getAttribute('action');
    const formDatas = Object.fromEntries(new FormData(formFilterevent).entries());
    let paramsToSend = "?";
    let inc = 0;
    // document.querySelector('.loader-overlay').classList.add('d-block');
    for (const data in formDatas) {
        if (inc === 0 && formDatas[data] !== null && formDatas[data] !== "") {
            paramsToSend = paramsToSend + data + "=" + formDatas[data];
            inc++;
        } else if (formDatas[data] !== null && formDatas[data] !== "") {
            paramsToSend = paramsToSend + "&" + data + "=" + formDatas[data];
        }
    }
    urlToSend = urlToSend + paramsToSend;

    fetch(urlToSend)
        .then(function (response) {
            return response.text();
        })
        .then(function (result) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(result, 'text/html');
            document.querySelector(wrapper).replaceWith(doc.querySelector(wrapper));
            // document.querySelector('.loader-overlay').classList.remove('d-block');
            if (document.querySelectorAll(".wrapper-pagination").length > 0) {
                if (doc.querySelectorAll(".wrapper-pagination").length > 0) {
                    document.querySelector(".wrapper-pagination").replaceWith(doc.querySelector(".wrapper-pagination"));
                } else {
                    document.querySelector(".wrapper-pagination").remove();
                }
            }
            if (document.querySelectorAll(".js-load-more-news").length > 0) {
                document.querySelector(".js-load-more-news").replaceWith(doc.querySelector(".js-load-more-news"));
                loadMoreNewsBtn(document.querySelector(".js-load-more-news"));
            }
        })
        .catch(function (error) {
            console.log(error);
        });
}

if (document.querySelectorAll('.select-multiple-custom').length > 0) {
    const selectItems = document.getElementById('selectItems');
    const displayText = document.getElementById('displayText');
    const selectedTagsContainer = document.getElementById('selectedTagsContainer');
    const spinner = document.getElementById('loadingSpinner'); // Add spinner element
    const wrapperItem = document.getElementById('wrapper-item'); // Add wrapper-blog element
    const selectedOptions = new Set();
    const queryParamName = 'categ';


    // Function to update the query parameter
    function updateQueryParam() {
        const queryParams = Array.from(selectedOptions).join(',');
        const searchParams = new URLSearchParams(window.location.search);
        if (queryParams) {
            searchParams.set(queryParamName, queryParams);
        } else {
            searchParams.delete(queryParamName);
        }

        const newURL = window.location.pathname + '?' + searchParams.toString();
        window.history.replaceState({}, '', newURL);

        // Show the spinner and hide the wrapper-blog during the process
        // spinner.style.display = 'flex ';
        wrapperItem.style.display = 'none';

        // Reload the page with the updated query parameter
        window.location.reload();

    }

    // Function to show all elements
    function showAllElements() {
        const items = document.querySelectorAll('.item');
        items.forEach((item) => {
            item.style.display = 'block';
        });
    }

    // Function to recreate tags from the query parameter
    function recreateTagsFromQueryParam() {
        const searchParams = new URLSearchParams(window.location.search);
        const queryParams = searchParams.get(queryParamName);

        if (queryParams) {
            const paramValues = queryParams.split(',');

            paramValues.forEach((value) => {
                const option = selectItems.querySelector(`[value="${value}"]`);
                if (option) {
                    displayText.classList.add('d-md-block');

                    const tag = document.createElement('div');
                    tag.className = 'selected-tag position-relative';
                    tag.innerHTML = `
                <label class="tagLabel">${option.innerText}</label>
                <button class="remove-tag"><i class="fa-solid fa-xmark stretched-link p-0"></i></button>
            `;

                    // Add a click event to remove the tag when clicked
                    tag.querySelector('.remove-tag').addEventListener('click', () => {
                        // Deselect the option
                        option.selected = false;
                        selectedTagsContainer.removeChild(tag);

                        // Remove the option from the selected options set
                        selectedOptions.delete(value);

                        // Update the query parameter
                        updateQueryParam();
                    });

                    selectedTagsContainer.appendChild(tag);
                    selectedOptions.add(value);
                } else {
                    displayText.classList.remove('d-md-block');

                }
            });

            // Refresh the display based on selected options
            refreshDisplay();
        }
    }

// Function to refresh the display based on selected options
    function refreshDisplay() {
        // Check if all categories are removed
        if (selectedOptions.size === 0 || selectedOptions.has('All')) {
            showAllElements();
        }
        
    }

    // Add an event listener to detect when the page is fully loaded
    window.addEventListener('load', () => {
        // Refresh the display based on selected options when the page is fully loaded
        refreshDisplay();
    });

    // Recreate tags from the query parameter on page load
    recreateTagsFromQueryParam();

    selectItems.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];

        // Check if an option was selected (not deselected)
        if (selectedOption && selectedOption.value) {
            // Check if the option has not been selected before
            if (!selectedOptions.has(selectedOption.value)) {

                const tag = document.createElement('div');
                tag.className = 'selected-tag position-relative';
                tag.innerHTML = `
            <label class="tagLabel">${selectedOption.innerText}</label>
            <button class="remove-tag"><i class="fa-solid fa-xmark stretched-link"></i></button>
        `;

                // Add the option to the selected options set
                selectedOptions.add(selectedOption.value);

                // Update the query parameter
                updateQueryParam();

                // Add a click event to remove the tag when clicked
                tag.querySelector('.remove-tag').addEventListener('click', () => {
                    // Deselect the option
                    selectedOption.selected = false;
                    selectedTagsContainer.removeChild(tag);

                    // Remove the option from the selected options set
                    selectedOptions.delete(selectedOption.value);

                    // Update the query parameter
                    updateQueryParam();

                    // Refresh the display based on selected options
                    refreshDisplay();
                });

                selectedTagsContainer.appendChild(tag);
            } else {
                // If the option has already been selected, deselect it
                selectedOption.selected = false;
            }

            // Refresh the display based on selected options
            refreshDisplay();
        }
    });
}


/*
* Datepicker event
* */
let inputCalendars = [];
 if (document.querySelectorAll('.input-date-event').length > 0) {
    let calendars = document.querySelectorAll('.input-date-event');
    for (const calendar of calendars) {
        inputCalendars[calendar.getAttribute('name')] = flatpickr(calendar, {
            allowInput: true,
            altInput: true,
            altFormat: "d-m-Y",
            disableMobile: "true",
            dateFormat: calendar.dataset.format ? calendar.dataset.format : "d-m-Y",

        });
    }
}

});


/*
        * Filter Event
        * */

if (document.querySelectorAll("#filterEvent").length > 0) {
    // console.log('#filterEvent detected')
    let eventFilters = document.querySelectorAll('.js-filter-event');
    let formFilterEvents = document.querySelector('#filterEvent');
    let resetEvent = document.querySelector('.js-reset-filter-event');

    resetEvent.addEventListener('click', (e) => {

        let inputStart = document.querySelector("input[name='datestart']");
        inputCalendars["datestart"].setDate("");
        inputStart.value = "";
        let inputEnd = document.querySelector("input[name='dateend']");
        inputCalendars["dateend"].setDate("");
        inputEnd.value = "";
        for (const eventFilter of eventFilters) {
            eventFilter.value = "";
            if (eventFilter.nodeName === "SELECT") {
                eventFilter.selectedIndex = null;
            }
        }
        setTimeout(function () {
            sendFilterForm(formFilterEvents, ".wrapper-events");
        }, 250);
    });

    for (const eventFilter of eventFilters) {


        eventFilter.addEventListener('change', (e) => {
            // console.log('change')
            sendFilterForm(formFilterEvents, ".wrapper-events");
        });
    }

    inputCalendars["datestart"].config.onChange.push(function () {
        sendFilterForm(formFilterEvents, ".wrapper-events");
        let allInputDate = document.querySelectorAll('.input-date-event');
        for (let inputDate of allInputDate) {
            // console.log(inputDate)
            inputDate.blur();
        }
    });

    inputCalendars["dateend"].config.onChange.push(function () {
        sendFilterForm(formFilterEvents, ".wrapper-events");
        let allInputDate = document.querySelectorAll('.input-date-event');
        for (let inputDate of allInputDate) {
            inputDate.blur();
        }
    });

    formFilterEvents.addEventListener("submit", function (e) {
        e.preventDefault();
        sendFilterForm(formFilterEvents, ".wrapper-events");
    });

}